// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-data-source-actions{background:#F6F6F6;border-bottom:1px solid #E5E5E5;display:flex;padding:1.3rem 3rem}.ac-data-source-actions__tabs{margin-left:auto;width:50rem}\n", ""]);
// Exports
module.exports = exports;
